/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DownpaymentAmount/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import * as fromPaymentplan from 'Data/payment-plan.js'
import LockAction from './LockAction/index'
import React from 'react'
import Slider from 'DesignSystem/Slider/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputCurrency from 'DesignSystem/TysiaInput/TysiaInputCurrency/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DownpaymentAmount({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/DownpaymentAmount"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let payorDownpaymentAmountValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'downpayment_amount',
})
let payorLockValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'lock',
})
let constantData = 'DOWNPAYMENT_AMOUNT'
let aggregateData = fromAggregate.equals(payorLockValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let payorDownpaymentAmountValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'downpayment_amount',
})
let payorLockValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'lock',
})
let constantData1 = 'DOWNPAYMENT_AMOUNT'
let aggregateData1 = fromAggregate.equals(payorLockValueData1, constantData1)
let payorValueData = fromData.useDataValue({ viewPath,
context: 'payor',
})
let paymentPlanValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
})
let settingsValueData = fromData.useDataValue({ viewPath,
context: 'settings',
})
let aggregateData2 = fromHelpers.getMinimumDownpaymentAmount(payorValueData, paymentPlanValueData, settingsValueData)
let payorValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
})
let paymentPlanValueData1 = fromData.useDataValue({ viewPath,
context: 'payment_plan',
})
let aggregateData3 = fromPaymentplan.getPayorShareAfterDiscounts(payorValueData1, paymentPlanValueData1)
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let onChange1 = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Downpayment"
 marginTop={dtSpaceS}
/>
<div
  data-testid="DownpaymentAmount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={dtSpaceXxs}
 maxWidth={200}
 data="payor.downpayment_amount"
 value={payorDownpaymentAmountValueData}
 onChange={onChange}
 data="payor.lock"
 data="'DOWNPAYMENT_AMOUNT'"
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputCurrency
{...childProps}
  viewPath={`${viewPath}/TysiaInputCurrency`}
 placeholder="$0.00"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
<Slider
  viewPath={`${viewPath}/Slider`}
 data="payor.downpayment_amount"
 value={payorDownpaymentAmountValueData1}
 onChange={onChange1}
 data="payor.lock"
 data="'DOWNPAYMENT_AMOUNT'"
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData1}
 width="auto"
 marginLeft={dtSpaceS}
 marginTop={dtSpaceLs}
 tabIndex={-1}
 flexGrow={1}
 flexShrink={1}
 flexBasis="auto"
 backgroundColor={dtColorsNeutral300}
 backgroundColorThumb={dtColorsBrandBase}
 backgroundColorThumbDisabled={dtColorsNeutral400}
 boxShadowThumb="0px 4px 12px 0px dt.colors.neutral.400"
 heightThumb={26}
 widthThumb={26}
 dataType="integer"
 data="payor"
 data="payment_plan"
 data="settings"
 aggregate="helpers.js getMinimumDownpaymentAmount"
 min={aggregateData2}
 data="payor"
 data="payment_plan"
 aggregate="/Data/payment-plan.js getPayorShareAfterDiscounts"
 max={aggregateData3}
 step={5}
 onMixMaxLabelFormatter={fromFormat.numberMoney}
/>
<LockAction
  viewPath={`${viewPath}/LockAction`}
/>
</div>
{children}
</React.Fragment>)
}